import React from 'react';
import { Form } from '../../../ui/universe';
import { getSelectRectKey } from '../utils';

/**
 * Qrcode 渲染器 - 二维码识别结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {Object} props.detail - 菜单详情配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const QrcodeRenderer = ({ params, config, detail, selectRect, onSelect }) => {
  return (
    <>
      {params.CodeResults?.map((code, index) => {
        const selectRectVal = getSelectRectKey({
          data: code,
          key: detail?.rectConfig?.RectKey,
          valStr: code.Url
        });

        return (
          <div
            className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''}`}
            key={index}
            onClick={() => {
              onSelect && onSelect(code[config.key], selectRectVal);
            }}
          >
            <Form.Item label="类型">{code.TypeName}</Form.Item>
            <Form.Item label="包含的地址">{code.Url}</Form.Item>
          </div>
        );
      })}
      {params.ImgSize && (
        <Form.Item label="图片大小">
          {`宽:${params.ImgSize.Wide}  高:${params.ImgSize.High}`}
        </Form.Item>
      )}
    </>
  );
};

export default QrcodeRenderer;
